import { render, staticRenderFns } from "./ArticleInfoMultimedijaTemplate.vue?vue&type=template&id=2a94c1f4&scoped=true"
import script from "./ArticleInfoMultimedijaTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoMultimedijaTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoMultimedijaTemplate.vue?vue&type=style&index=0&id=2a94c1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94c1f4",
  null
  
)

export default component.exports